/* Refactor
	Don't bundle calls for separate parts of the application in one place.
	Reason: separation of concerns and single responsibility principle
 */

import { requestApi, throwError } from './api.js';
// import config from './../store/index.js';
const host = '/'; // config.siteHostname;

const endpoints = {
	login: `${host}player/session/login`,
	logout: `${host}player/session/logout`,
	toggleLoveGame: `${host}rest/mygames/lovedgames`,
	lovedGames: `${host}rest/mygames/lovedgames/mobile`,
	toggleRecentGames: `${host}rest/mygames/recentlyplayedgames`,
	recentGames: `${host}rest/mygames/recentlyplayedgames/mobile`,
	sportsbookStatus: `${host}sportsbook/status`,
	site: `${host}site`
};
async function getDefaultPath() {
	try {
		const {result} = await requestApi(endpoints.site);
		return result;
	} catch (err) {
		throwError(err);
	}
}
/**
 * @todo following shall be refactored to dry up a bit.
 * For now repetetion will do.
 */
async function login(payload){
	try {
		const response = await requestApi(endpoints.login, payload, 'POST');
		return response;
	} catch (err) {
		throwError(err);
	}
}
async function logout(payload){
	try {
		const response = await requestApi(endpoints.logout);
		return response;
	} catch (err) {
		throwError(err);
	}
}
async function sportsbookStatus(){
	try {
		const response = await requestApi(endpoints.sportsbookStatus);
		return response;
	} catch (err) {
		throwError(err);
	}
}
async function lovedGames(){
	try {
		const response = await requestApi(endpoints.lovedGames);
		return response;
	} catch (err) {
		throwError(err);
	}
}
async function loveGame(payload){
	try {
		const response = await requestApi(endpoints.toggleLoveGame, payload, 'PUT');
		return response;
	} catch (err) {
		throwError(err);
	}
}
async function unLoveGame(payload){
	try {
		const response = await requestApi(endpoints.toggleLoveGame, payload, 'DELETE');
	} catch (err) {
		throwError(err);
	}
}
async function recentGames(){
	try {
		const response = await requestApi(endpoints.recentGames);
		return response;
	} catch (err) {
		throwError(err);
	}
}
async function setRecentGames(payload){
	try {
		const response = await requestApi(endpoints.toggleRecentGames, payload, 'PUT');
		return response;
	} catch (err) {
		throwError(err);
	}
}

export {
	login,
	logout,
	lovedGames,
	loveGame,
	unLoveGame,
	recentGames,
	setRecentGames,
	sportsbookStatus,
	getDefaultPath
};



// WEBPACK FOOTER //
// ./mobile-core/src/services/rest.js